module.exports = "/assets/landing-cf/team-placeholder.jpg?Ug5A+7/";